import React, { Component } from 'react'
import moment from 'moment'
import { Row, Col, Spin, Card } from 'antd'

class JobsAdded extends Component {
  renderJobSiteWorkCard = job => {
    return (
      <Card title="Site Work" type="inner">
        {job.schedule.siteWorks.map(row => {
          return (
            <Row key={row.id}>
              <Row>
                {job.schedule.siteWorks.length > 1 && <h5 className="marginTop20">{row.name}</h5>}
                <Col span={6}>
                  <p>
                    <dt>Customer Requested Start</dt>
                    <dd>
                      {(row.release_for_manufacturing_date &&
                        moment(row.release_for_manufacturing_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
                <Col span={6}>
                  <p>
                    <dt>Estimated Start</dt>
                    <dd>
                      {(row.estimated_start_date &&
                        moment(row.estimated_start_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Confirmed Start</dt>
                      <dd>
                        {(row.confirmed_start_date &&
                          moment(row.confirmed_start_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
              </Row>
              <Row>
                <Col span={6}>
                  <p>
                    <dt>Estimated Adjusting</dt>
                    <dd>
                      {(row.estimated_adjusting_date &&
                        moment(row.estimated_adjusting_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
                <Col span={6}>
                  <p>
                    <dt>Confirmed Adjusting</dt>
                    <dd>
                      {(row.confirmed_adjusting_date &&
                        moment(row.confirmed_adjusting_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
              </Row>
              <Row>
                {job.type !== 'Modernization' &&
                  job.type !== 'Repair' && (
                    <Col span={6}>
                      <p>
                        <dt>BEC Inspection</dt>
                        <dd>
                          {(row.bec_inspection_date &&
                            moment(row.bec_inspection_date).format('YYYY-M-D')) ||
                            'Not Entered'}
                        </dd>
                      </p>
                    </Col>
                  )}
                {job.type !== 'Repair' && (
                  <Col span={6}>
                    <p>
                      <dt>Received Temporary Construction Use Amendment</dt>
                      <dd>
                        {(row.received_temporary_construction_use_amendment_date &&
                          moment(row.received_temporary_construction_use_amendment_date).format(
                            'YYYY-M-D'
                          )) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Final Inspection</dt>
                      <dd>
                        {(row.final_inspection_date &&
                          moment(row.final_inspection_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type === 'Repair' && (
                  <Col span={6}>
                    <p>
                      <dt>Final Turnover Date</dt>
                      <dd>
                        {(row.final_turnover_date &&
                          moment(row.final_turnover_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
              </Row>
              <Row>
                {job.type !== 'Modernization' &&
                  job.type !== 'Repair' && (
                    <Col span={6}>
                      <p>
                        <dt>Temporary Construction Use Inspection</dt>
                        <dd>
                          {(row.temporary_construction_use_inspection_date &&
                            moment(row.temporary_construction_use_inspection_date).format(
                              'YYYY-M-D'
                            )) ||
                            'Not Entered'}
                        </dd>
                      </p>
                    </Col>
                  )}
              </Row>
            </Row>
          )
        })}
      </Card>
    )
  }

  renderJobPermitsCard = job => {
    return (
      <Card title="Applications/Permits" type="inner">
        {job.schedule.applications.map(row => {
          return (
            <Row key={row.id}>
              {job.schedule.applications.length > 1 && <h5 className="marginTop20">{row.name}</h5>}
              <Row>
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Requested BEC</dt>
                      <dd>
                        {(row.release_for_manufacturing_date &&
                          moment(row.release_for_manufacturing_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Received BEC</dt>
                      <dd>
                        {(row.received_bec_date &&
                          moment(row.received_bec_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>BEC Permit Expiration</dt>
                      <dd>
                        {(row.bec_permit_expiration_date &&
                          moment(row.bec_permit_expiration_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
              </Row>
              <Row>
                <Col span={6}>
                  <p>
                    <dt>Requested Elevator Application</dt>
                    <dd>
                      {(row.requested_elevator_application_date &&
                        moment(row.requested_elevator_application_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
                <Col span={6}>
                  <p>
                    <dt>Received Elevator Application</dt>
                    <dd>
                      {(row.received_elevator_application_date &&
                        moment(row.received_elevator_application_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
                <Col span={6}>
                  <p>
                    <dt>Elevator Application Expiration</dt>
                    <dd>
                      {(row.elevator_application_expiration_date &&
                        moment(row.elevator_application_expiration_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
              </Row>
              <Row>
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Requested Temporary Construction Use Amendment</dt>
                      <dd>
                        {(row.requested_temporary_construction_use_amendment_date &&
                          moment(row.requested_temporary_construction_use_amendment_date).format(
                            'YYYY-M-D'
                          )) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Received Temporary Construction Use Amendment</dt>
                      <dd>
                        {(row.received_temporary_construction_use_amendment_date &&
                          moment(row.received_temporary_construction_use_amendment_date).format(
                            'YYYY-M-D'
                          )) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Temporary Construction Use Inspection Request</dt>
                      <dd>
                        {(row.temporary_construction_use_inspection_request_date &&
                          moment(row.temporary_construction_use_inspection_request_date).format(
                            'YYYY-M-D'
                          )) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>Temporary Construction Use Inspection Expiration</dt>
                      <dd>
                        {(row.temporary_construction_use_inspection_expiration_date &&
                          moment(row.temporary_construction_use_inspection_expiration_date).format(
                            'YYYY-M-D'
                          )) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
              </Row>
              <Row>
                {job.type !== 'Repair' && (
                  <Col span={6}>
                    <p>
                      <dt>Final Inspection Request</dt>
                      <dd>
                        {(row.final_inspection_request_date &&
                          moment(row.final_inspection_request_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
                {job.type !== 'Modernization' && (
                  <Col span={6}>
                    <p>
                      <dt>BEC Inspection Request</dt>
                      <dd>
                        {(row.bec_inspection_request_date &&
                          moment(row.bec_inspection_request_date).format('YYYY-M-D')) ||
                          'Not Entered'}
                      </dd>
                    </p>
                  </Col>
                )}
              </Row>
            </Row>
          )
        })}
      </Card>
    )
  }

  renderJobManufacturingCard = job => {
    return (
      <Card title="Manufacturing" type="inner">
        <Row>
          {job.type !== 'Modernization' &&
            job.type !== 'Repair' && (
              <Col span={6}>
                <p>
                  <dt>CRL Sent</dt>
                  <dd>
                    {(job.schedule.crl_sent_date &&
                      moment(job.schedule.crl_sent_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
            )}
          {job.type !== 'Modernization' &&
            job.type !== 'Repair' && (
              <Col span={6}>
                <p>
                  <dt>CRL Sent</dt>
                  <dd>
                    {(job.schedule.crl_received_date &&
                      moment(job.schedule.crl_received_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
            )}
        </Row>
        {job.schedule.manufacturings.map(row => {
          return (
            <Row key={row.id}>
              {job.schedule.manufacturings.length > 1 && (
                <h5 className="marginTop20">{row.name}</h5>
              )}
              {job.type !== 'Repair' && (
                <Col span={6}>
                  <p>
                    <dt>Release for Manufacturing</dt>
                    <dd>
                      {(row.release_for_manufacturing_date &&
                        moment(row.release_for_manufacturing_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
              )}
              {job.type !== 'Repair' && (
                <Col span={6}>
                  <p>
                    <dt>Requested Preliminary Layout Drawings</dt>
                    <dd>
                      {(row.requested_shipment_date &&
                        moment(row.requested_shipment_date).format('YYYY-M-D')) ||
                        'Not Entered'}
                    </dd>
                  </p>
                </Col>
              )}
              <Col span={6}>
                <p>
                  <dt>Estimated Shipment</dt>
                  <dd>
                    {(row.estimated_shipment_date &&
                      moment(row.estimated_shipment_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Confirmed Shipment</dt>
                  <dd>
                    {(row.confirmed_shipment_date &&
                      moment(row.confirmed_shipment_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Estimated Delivery</dt>
                  <dd>
                    {(row.estimated_delivery_date &&
                      moment(row.estimated_delivery_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Confirmed Delivery</dt>
                  <dd>
                    {(row.confirmed_delivery_date &&
                      moment(row.confirmed_delivery_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
            </Row>
          )
        })}
      </Card>
    )
  }

  renderJobDrawingsCard = drawings => {
    return (
      <Card title="Drawings" type="inner">
        {drawings.map(row => {
          return (
            <Row key={row.id}>
              {drawings.length > 1 && <h5 className="marginTop20">{row.name}</h5>}
              <Col span={6}>
                <p>
                  <dt>Requested Preliminary Layout Drawings</dt>
                  <dd>
                    {(row.requested_preliminary_layout_drawings_date &&
                      moment(row.requested_preliminary_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Received Preliminary Layout Drawings</dt>
                  <dd>
                    {(row.received_preliminary_layout_drawings_date &&
                      moment(row.received_preliminary_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Sent Preliminary Layout Drawings</dt>
                  <dd>
                    {(row.sent_preliminary_layout_drawings_date &&
                      moment(row.sent_preliminary_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Requested Final Layout Drawings</dt>
                  <dd>
                    {(row.requested_final_layout_drawings_date &&
                      moment(row.requested_final_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Received Final Layout Drawings</dt>
                  <dd>
                    {(row.received_final_layout_drawings_date &&
                      moment(row.received_final_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Sent Final Layout Drawings</dt>
                  <dd>
                    {(row.sent_final_layout_drawings_date &&
                      moment(row.sent_final_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Final Approved Layout Drawings</dt>
                  <dd>
                    {(row.final_approved_layout_drawings_date &&
                      moment(row.final_approved_layout_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Requested Preliminary Design Drawings</dt>
                  <dd>
                    {(row.requested_preliminary_design_drawings_date &&
                      moment(row.requested_preliminary_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Received Preliminary Design Drawings</dt>
                  <dd>
                    {(row.received_preliminary_design_drawings_date &&
                      moment(row.received_preliminary_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Sent Preliminary Design Drawings</dt>
                  <dd>
                    {(row.sent_preliminary_design_drawings_date &&
                      moment(row.sent_preliminary_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Requested Final Design Drawings</dt>
                  <dd>
                    {(row.requested_final_design_drawings_date &&
                      moment(row.requested_final_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Received Final Design Drawings</dt>
                  <dd>
                    {(row.received_final_design_drawings_date &&
                      moment(row.received_final_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Sent Final Design Drawings</dt>
                  <dd>
                    {(row.sent_final_design_drawings_date &&
                      moment(row.sent_final_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
              <Col span={6}>
                <p>
                  <dt>Final Approved Design Drawings</dt>
                  <dd>
                    {(row.final_approved_design_drawings_date &&
                      moment(row.final_approved_design_drawings_date).format('YYYY-M-D')) ||
                      'Not Entered'}
                  </dd>
                </p>
              </Col>
            </Row>
          )
        })}
      </Card>
    )
  }

  renderJobOverviewCard = job => {
    return (
      <Card title="Overview">
        {job.type !== 'Maintenance/Service' && (
          <p>
            <dt>Executed Contract</dt>
            <dd>
              {(job.schedule.schedule_executed_contract_date &&
                moment(job.schedule.schedule_executed_contract_date).format('YYYY-M-D')) ||
                'Not Entered'}
            </dd>
          </p>
        )}
        {job.type !== 'Material Sale' &&
          job.type !== 'Maintenance/Service' && (
            <p>
              <dt>AIA Due Day</dt>
              <dd>{job.aia_due_day || 'Not Entered'}</dd>
            </p>
          )}
        {job.type !== 'Material Sale' &&
          job.type !== 'Maintenance/Service' && (
            <p>
              <dt>AIA Expected Pay Day</dt>
              <dd>{job.aia_expected_pay_day || 'Not Entered'}</dd>
            </p>
          )}
        {job.type === 'Maintenance/Service' && (
          <p>
            <dt>Monthly Invoice Date</dt>
            <dd>{job.monthly_invoice_day || 'Not Entered'}</dd>
          </p>
        )}
        {job.type === 'Maintenance/Service' && (
          <p>
            <dt>CAT 1 Due</dt>
            <dd>
              {(job.schedule.schedule_cat1_due_date &&
                moment(job.schedule.schedule_cat1_due_date).format('YYYY-M-D')) ||
                'Not Entered'}
            </dd>
          </p>
        )}
        {job.type === 'Maintenance/Service' && (
          <p>
            <dt>CAT 5 Due</dt>
            <dd>
              {(job.schedule.schedule_cat5_due_date &&
                moment(job.schedule.schedule_cat5_due_date).format('YYYY-M-D')) ||
                'Not Entered'}
            </dd>
          </p>
        )}
        {job.type === 'Maintenance/Service' && (
          <p>
            <dt>Targeted Monthly Visit Day</dt>
            <dd>{job.schedule.schedule_targeted_monthly_visit_day || 'Not Entered'}</dd>
          </p>
        )}

        {job.type !== 'Repair' &&
          job.type !== 'Maintenance/Service' &&
          this.renderJobDrawingsCard(job.schedule.drawings)}
        {job.type !== 'Maintenance/Service' && this.renderJobManufacturingCard(job)}
        {job.type !== 'Repair' &&
          job.type !== 'Material Sale' &&
          job.type !== 'Maintenance/Service' &&
          this.renderJobPermitsCard(job)}
        {job.type !== 'Material Sale' &&
          job.type !== 'Maintenance/Service' &&
          this.renderJobSiteWorkCard(job)}
      </Card>
    )
  }

  renderJobCard = job => {
    return (
      <Card key={job.id} title={job.name}>
        {this.renderJobOverviewCard(job)}
      </Card>
    )
  }

  render() {
    const { loadingFullReport, fullReport } = this.props

    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport && fullReport && fullReport.map(this.renderJobCard)}
      </div>
    )
  }
}

export default JobsAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/schedule-report/ListItems.js